<template>
  <section>
    <validation-observer ref="form">
      <div v-if="confirmationMode && !confirmationModeReadOnly" class="">
        <h3 id="confirmation-mode">Confirmação de pedido</h3>
      </div>
      <div>
        <div v-for="(product, index) in collection" :key="index">
          <hr v-if="index > 0" />
          <div :id="`top-widget-${index}`" class="flex rows top-widget">
            <!-- photo -->
            <div class="item photo simulator" :class="{ maxconfirmation: confirmationMode }">
              <div
                v-if="collection.length > 1 && !confirmationMode"
                @click="deleteProduct(index)"
                class="btn delete-btn secondary"
              >
                <i class="far fa-trash-alt"></i>
              </div>
              <div
                v-if="!confirmationMode"
                class="simulator-position"
                :class="{ onlyName: product.pet_name && !product.pet_phone }"
              >
                <div class="name-simulator">
                  {{ product.pet_name && product.pet_name.toUpperCase() }}
                </div>
                <div class="phone-simulator">
                  {{ product.pet_phone && product.pet_phone.toUpperCase() }}
                </div>
              </div>
              <img class="simulator-photo" :src="decodeImage(product.color)" />
            </div>
            <!-- data -->
            <div v-if="!confirmationMode" class="item">
              <div class="flex columns">
                <!-- informations -->
                <div class="item">
                  <div class="flex columns">
                    <div class="item">
                      <h2>
                        Coleira Peitoral Personalizada
                        <span style="font-size: 37px; font-weight: 700">
                          BOPOTY
                        </span>
                      </h2>
                    </div>
                    <div class="item">
                      <h2 class="current-price">
                        <span
                          style="position:relative; color: #000; font-size: 24px; font-weight: 400"
                        >
                          <span
                            style=" position: absolute; border-bottom: 2px solid #000; width: 100%; top: 50%; left: -2px; "
                          ></span>
                          R$ {{ parseInt(product.price) * 2 }}
                        </span>
                        <span
                          style="color: #000; font-size: 24px; font-weight: 400"
                          >por</span
                        >
                        R$
                        {{ product.price }}
                      </h2>
                    </div>
                    <div class="item">
                      <h2>
                        ou apenas <b>12x</b> de
                        <b>
                          <span class="current-price-parcela"
                            >R$ {{ product.price_parcel }}
                          </span></b
                        >
                        <!-- <span class="nojuros">sem juros!</span> -->
                      </h2>
                    </div>
                    <div class="item">
                      Promoção de <b>FRETE GRÁTIS</b> por tempo limitado!
                    </div>
                  </div>
                </div>
                <hr />

                <!-- color -->
                <div class="item">
                  <div class="flex columns">
                    <div class="item">
                      <h3>
                        <span style="font-weight:400">Modelo: </span
                        ><span id="current-color">{{
                          colorName(product.color)
                        }}</span>
                      </h3>
                    </div>
                    <div class="item">
                      <div class="flex wrap">
                        <div
                          v-for="(color, indexColor) in modelRender()"
                          :key="indexColor"
                        >
                          <div
                            :class="{
                              active: product.color == color.value,
                              'color-3514724_1': color.value == '3514724_1',
                              'color-3514724_2': color.value == '3514724_2',
                              'color-3514724_3': color.value == '3514724_3',
                              'color-3514724_4': color.value == '3514724_4',
                              'color-3514724_5': color.value == '3514724_5',
                              'color-3514724_6': color.value == '3514724_6',
                              'color-3514724_7': color.value == '3514724_7',
                              'color-3514724_8': color.value == '3514724_8',
                              'color-3514724_9': color.value == '3514724_9',
                            }"
                            class="item btn w-color"
                            style="margin-left: 5px;"
                            @click="product.color = color.value"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- size -->
                <div class="item">
                  <div class="flex columns">
                    <div class="item">
                      <h3>
                        <span style="font-weight:400">Tamanho: </span>
                        <span id="current-size">{{ product.size }} <small>({{ _decode_size_to_kg(product.size) }})</small></span>
                      </h3>
                    </div>
                    <div class="item" style="max-width: 400px">
                      <div class="flex wrap">
                        <div
                          v-for="(size, indexSize) in sizes"
                          :key="indexSize"
                        >
                          <div
                            :class="{
                              active: product.size == size,
                              'no-margin-left': indexSize == 0,
                            }"
                            class="item btn w-size"
                            @click="changeSizeProduct(index, size)"
                          >
                            {{ size }}
                            <div>
                              <small>({{ _decode_size_to_kg(size) }})</small>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- customization -->
                <div class="item">
                  <div class="flex columns">
                    <validation-provider
                      :vid="`pet-name-${index}`"
                      name="Nome do PET"
                      rules="max:10"
                      v-slot="{ errors }"
                    >
                      <div class="group-input" :class="{ errors: errors[0] }">
                        <div class="item">
                          <h3>Nome do PET:</h3>
                        </div>
                        <div class="item">
                          <input
                            v-model="product.pet_name"
                            name="custom-name-dog"
                            type="text"
                            maxlength="10"
                          />
                          <span class="erros-alert">{{ errors[0] }}</span>
                        </div>
                      </div>
                    </validation-provider>
                    <validation-provider
                      :vid="`pet-phone-${index}`"
                      name="Telefone"
                      rules="max:15|min:14"
                      v-slot="{ errors }"
                    >
                      <div class="group-input" :class="{ errors: errors[0] }">
                        <div class="item">
                          <h3>Telefone (Opcional):</h3>
                        </div>
                        <div class="item">
                          <input
                            class="phone_with_ddd"
                            v-model="product.pet_phone"
                            name="custom-phone-dog"
                            type="text"
                            v-mask="['(##) ####-####', '(##) #####-####']"
                            maxlength="15"
                            minlength="14"
                          />
                          <span class="erros-alert">{{ errors[0] }}</span>
                        </div>
                      </div>
                    </validation-provider>

                    <div class="item">
                      <a
                        :href="`#top-widget-${index}`"
                        style="text-decoration: none; color: #000;"
                      >
                        <div class="btn secondary">
                          Ver Coleira personalizada
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-else>
              <div v-if="collection && collection.length > 1  && false">
                <h4>Peitoral: {{ index + 1 }}</h4>
              </div>
              <!-- confirmation data -->
              <div v-if="product.size">
                <h4>Tamanho: {{ product.size }} <small>({{ _decode_size_to_kg(product.size) }})</small></h4>
              </div>
              <div v-if="product.pet_name">
                <h4>Nome do Pet: {{ product.pet_name }}</h4>
              </div>
              <div v-if="product.phone">
                <h4>Telefone: {{ product.phone }}</h4>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="!confirmationMode" class="action">
        <div v-if="collection && collection.length < 2">
          <p style="text-align:center">
            <b>ATENÇÃO</b>: Ao comprar <b>2 únidades</b> ou mais você ganha

            <span style="font-size:18px"><b>10% de desconto</b></span
            >!!!
          </p>
          <p style="text-align:center">
            <small>*Oferta valida apenas para compras feitas HOJE.</small>
          </p>
        </div>
        <div v-else>
          <p style="text-align:center">
            Parabéns, você <b>ganhou 10 % de desconto</b>. Oferta valida apenas
            para compras feitas HOJE!
          </p>
        </div>

        <div class="btn secondary" @click="addNewProduct()">
          + Adicionar mais uma
        </div>

        <!-- button -->
        <div
          @click="confirmationMode = true"
          id="buy-link"
          style="text-decoration: none;color: #000;"
        >
          <div class="btn buy button-animate">
            Comprar Agora
            <div>
              <small>(Clique Aqui)</small>
            </div>
          </div>
        </div>
      </div>

      <div v-else-if="!confirmationModeReadOnly" class="flex center columns">
        <div style="max-width: 410px;">
          <div v-show="false" style="margin-top:20px">
            *<b>Observação</b>: Pode haver uma margem de erro entre 1-3cm devido
            a medição manual, e pode existir uma pequena diferença de cor de
            acordo com as imagens.
          </div>
          <div style="margin-top:20px">
            *<b>Atenção</b>: Ao clicar em confirmar você está confirmando todos
            os dados da personalização. Vamos produzir a coleira exatamente com
            os dados informados. Caso tenha algo para alterar clique em
            <b>VOLTAR</b>.
          </div>
        </div>

        <div style="max-width: 410px; margin-top: 20px; width: 100%">
          <validation-provider
            vid="order-phone-confirmed"
            name="Telefone"
            rules="required|max:15|min:14"
            v-slot="{ errors }"
          >
            <div class="group-input" :class="{ errors: errors[0] }">
              Informe seu número de celular
              <div class="item">
                <input
                  v-model="order_phone"
                  name="order_phone"
                  type="text"
                  v-mask="['(##) ####-####', '(##) #####-####']"
                  maxlength="15"
                  minlength="14"
                />
                <span class="erros-alert">{{ errors[0] }}</span>
              </div>
            </div>
          </validation-provider>
        </div>

        <div style="max-width: 410px;">
          <div style="margin-top:20px flex center">
            <div class="btn primary" @click="buyProducts()">
              CONFIRMAR PEDIDO
              <div><small>(Clique Aqui)</small></div>
            </div>
            <div class="btn secondary" @click="confirmationMode = false">
              VOLTAR
            </div>
          </div>
        </div>
      </div>

      <div v-if="loader" id="background-loader">
        <div class="loader" id="loader"></div>
        <p>Carregando...</p>
      </div>
    </validation-observer>
  </section>
</template>

<script>
import { mask } from "vue-the-mask";

const mapping_size_to_kg = {
  PP: "2-4 kg",
  P: "5-8 kg",
  M: "9-17 kg",
  G: "18-30 kg",
  GG: "31-43 kg",
  XG: "44-60 kg",
}

const mapping_price = {
  PP: "154,90",
  P: "154,90",
  M: "154,90",
  G: "154,90",
  GG: "154,90",
  XG: "154,90",
};

const mapping_parcel_price = {
  PP: "15,96",
  P: "15,96",
  M: "15,96",
  G: "15,96",
  GG: "15,96",
  XG: "15,96",
};

const mapping_product_to_model = {
  "3514724_4": "Vermelho",
  "3514724_5": "Azul",
  "3514724_2": "Rosa",
  "3514724_3": "Roxo",
  "3514724_6": "Rosa Pink",
  "3514724_8": "Preta",
  "3514724_1": "Verde",
  "3514724_7": "Camuflada Azul",
  "3514724_9": "Camuflada",
};

const mapping_product = {
  // verde
  "3514724_1 PP": "HR65A451VI",
  "3514724_1 P": "QMX71KFSPJ",
  "3514724_1 M": "61NBEZSRCV",
  "3514724_1 G": "RZWZPHGJBT",
  "3514724_1 GG": "97F3Y8S2HZ",
  "3514724_1 XG": "KWHON24ONV",
  // rosa
  "3514724_2 PP": "OU4NE3Z4OZ",
  "3514724_2 P": "506DLQ1F6I",
  "3514724_2 M": "H7A39OX4ZA",
  "3514724_2 G": "SWCVUOQEDL",
  "3514724_2 GG": "LDH6XBADXH",
  "3514724_2 XG": "MSDGRVN361",
  // roxo
  "3514724_3 PP": "OARHHI9QYF",
  "3514724_3 P": "6PN4WODQRI",
  "3514724_3 M": "I0N59PKO2C",
  "3514724_3 G": "H8RQMEYPJV",
  "3514724_3 GG": "LU9U1JCN4N",
  "3514724_3 XG": "IY1TV89AL6",
  // vermelho
  "3514724_4 PP": "3B550WDNFP",
  "3514724_4 P": "GFZ9NAZ8DF",
  "3514724_4 M": "2JLI5N961Q",
  "3514724_4 G": "FFHYOAVDBC",
  "3514724_4 GG": "RQ551NV47A",
  "3514724_4 XG": "3KDXDBESNN",
  // azul
  "3514724_5 PP": "PYTJLBEBIV",
  "3514724_5 P": "51MW40370P",
  "3514724_5 M": "AFWM3JYWK5",
  "3514724_5 G": "9N9D89I8WC",
  "3514724_5 GG": "MU1EZRJMIY",
  "3514724_5 XG": "GMRYF1351G",
  // rosa pink
  "3514724_6 PP": "GZOEZ7C9BT",
  "3514724_6 P": "PKMCY0HCXQ",
  "3514724_6 M": "4VCHH7Q9M5",
  "3514724_6 G": "HK7XHZRB52",
  "3514724_6 GG": "6HDN7QK1BF",
  "3514724_6 XG": "9YH0YG7490",
  // camuflada azul
  "3514724_7 PP": "M9ZTBIG6C7",
  "3514724_7 P": "HKASIORZ1C",
  "3514724_7 M": "KPNAPC0MMN",
  "3514724_7 G": "BI7OQ2UHKV",
  "3514724_7 GG": "IR67ZMFJGC",
  "3514724_7 XG": "B3LB5HGFNZ",
  // preta
  "3514724_8 PP": "SM737FK666",
  "3514724_8 P": "JVAU36N5SE",
  "3514724_8 M": "3JC32L559W",
  "3514724_8 G": "2KQMUE02XX",
  "3514724_8 GG": "E5YDELM2RR",
  "3514724_8 XG": "4W522Y72ON",
  // camuflada
  "3514724_9 PP": "573YR9SFXK",
  "3514724_9 P": "8ZDGPZMAAZ",
  "3514724_9 M": "QX0AEOE63Q",
  "3514724_9 G": "E7DPSUBS29",
  "3514724_9 GG": "PB510R94JM",
  "3514724_9 XG": "CZSGM8P6XZ",
};

import Model3514724_1 from "@/assets/imgs/verde.png";
import Model3514724_2 from "@/assets/imgs/rosa.png";
import Model3514724_3 from "@/assets/imgs/roxo.png";
import Model3514724_4 from "@/assets/imgs/vermelho.png";
import Model3514724_5 from "@/assets/imgs/azul.png";
import Model3514724_6 from "@/assets/imgs/rosa-pink.png";
import Model3514724_7 from "@/assets/imgs/camuflada-azul.png";
import Model3514724_8 from "@/assets/imgs/preta.png";
import Model3514724_9 from "@/assets/imgs/camuflada.png";

const imagesColor = {
  // product 1
  "3514724_1": Model3514724_1,
  "3514724_2": Model3514724_2,
  "3514724_3": Model3514724_3,
  "3514724_4": Model3514724_4,
  "3514724_5": Model3514724_5,
  "3514724_6": Model3514724_6,
  "3514724_7": Model3514724_7,
  "3514724_8": Model3514724_8,
  "3514724_9": Model3514724_9,
};

const emptyProduct = {
  price: "154,90",
  price_parcel: "15,96",
  color: "3514724_4",
  size: "PP",
  pet_name: null,
  pet_phone: null,
};

export default {
  directives: { mask },
  name: "simulator",
  data() {
    return {
      loader: false,
      confirmationMode: false,
      confirmationModeReadOnly: false,
      order_phone: "",
      collection: [Object.assign({}, emptyProduct)],
      colors: Object.values(mapping_product_to_model),
      sizes: ["PP", "P", "M", "G", "GG", "XG"],
    };
  },
  computed: {},
  mounted() {
    let confirmation_mode_csa = window.location.search || "";

    if (confirmation_mode_csa.includes("?confirmation_mode_csa")) {
      this.confirmationMode = true;
      this.confirmationModeReadOnly = true;
    }

    if (confirmation_mode_csa.includes("frase_simulator=")) {
      this.showSubTitle = true;
    }
  },
  methods: {
    _decode_size_to_kg(size) {
      return mapping_size_to_kg[size];
    }, 
    modelRender() {
      let result = [];

      Object.keys(mapping_product_to_model).forEach((e) => {
        result.push({
          value: e,
          name: mapping_product_to_model[e],
        });
      });
      return result;
    },
    colorName(productId) {
      return mapping_product_to_model && mapping_product_to_model[productId];
    },
    addNewProduct() {
      this.collection.push(Object.assign({}, emptyProduct));
    },
    deleteProduct(index) {
      if (window.confirm("Você realmente quer remover o produto?")) {
        this.collection.splice(index, 1);
      }
    },
    sendConfirmation(custom_info) {
      if (!custom_info) {
        // not send request in case not exist values =/
        this.loader = false;
        return;
      }
      custom_info = encodeURIComponent(custom_info);

      let cleanPhone = this.order_phone;

      // send data to backend
      let params = `phone_order=${cleanPhone}&custom_info=${custom_info}`;

      fetch(`https://api.compresoagora.com/confirmation?${params}`)
        .then((response) => {
          console.log(response);
          this.formatUrlToYampi();
        })
        .catch((e) => {
          console.log(e);
          this.loader = false;
          alert("Ocorreu algum problema, tente novamente!");
        });
    },
    buyProducts() {
      // save cookie product :)
      this.$refs.form.validate().then((success) => {
        if (!success) {
          alert(
            "Você precisa preencher o número de celular para confirmar o pedido."
          );
          return;
        }

        this.loader = true;

        let saveInfoProducts = [];

        this.collection.forEach((p) => {
          saveInfoProducts.push({
            color: null,
            size: p.size,
            has_subtitle: p.has_subtitle,
            pet_name: p.pet_name,
            pet_phone: p.pet_phone,
            order_phone: this.order_phone,
            custom_product: {
              type: 'COLEIRA-PEITORAL'
            },
          });
        });

        console.log(JSON.stringify(saveInfoProducts));

        this.setCookie("cp-coleira-csa", JSON.stringify(saveInfoProducts));

        this.sendConfirmation(JSON.stringify(saveInfoProducts));
      });
    },
    formatUrlToYampi() {
      this.loader = true;
      // generate url
      let productsCode = [];

      // parsing collection to calculate quantity

      let aux_collection = {};

      this.collection.forEach((p) => {
        // get code checkout
        let key = `${p.color} ${p.size}`;
        let productCode = mapping_product[key];
        // exist object
        if (Object.keys(aux_collection).includes(productCode)) {
          aux_collection[productCode].quantity += 1;
        } else {
          aux_collection[productCode] = {
            productCode: productCode,
            quantity: 1,
          };
        }
      });

      // create url
      Object.keys(aux_collection).forEach((p) => {
        // get code checkout
        let productCode = aux_collection[p].productCode;
        let quantity = aux_collection[p].quantity;

        productsCode.push(`${productCode}:${quantity}`);
      });

      let url = `https://seguro.compresoagora.com/r/${productsCode.join(",")}`;

      let cleanPhone =
        this.order_phone &&
        this.order_phone
          .replace("(", "")
          .replace(")", "")
          .replace("-", "")
          .replace(" ", "");
      // check exist UTM in link
      const search = window.location.search || "";
      if (search) {
        // remove utm_term and add phone confirmation

        let splitSearch = search.split("&");

        let newSearchList = [];
        splitSearch.forEach((e) => {
          if (!e.includes("utm_term=")) {
            newSearchList.push(e);
          }
        });

        let newSearch = newSearchList.join("&");

        url += newSearch;
      }

      // 10% off in buy 2 products
      if (this.collection && this.collection.length > 1) {
        if (url && url.includes("?")) {
          url += "&promocode=10%OFF";
        } else {
          url += `?promocode=10%OFF`;
        }
      }

      if (url && url.includes("?")) {
        url += `&utm_term=${cleanPhone}`;
      } else {
        url += `?utm_term=${cleanPhone}`;
      }

      // redirect
      window.top.location.href = url;

      this.loader = false;
    },
    decodeImage(color) {
      return imagesColor[color];
    },
    changeSizeProduct(index, size) {
      this.collection[index].size = size;

      this.collection[index].price = mapping_price[size];
      this.collection[index].price_parcel = mapping_parcel_price[size];
    },
    setCookie(name, value) {
      const date = new Date();
      const days = 30;
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      const expires = "; expires=" + date.toGMTString();
      document.cookie =
        name + "=" + value + expires + "; path=/;domain=compresoagora.com";
      // document.cookie = name + "=" + value + expires + "; path=/";
    },
  },
};
</script>

<style lang="scss" scoped>
body {
  background-color: #ffffff;
}
.flex {
  display: flex !important;
}
.wrap {
  flex-flow: wrap;
}
h2 {
  margin-top: 5px;
  margin-bottom: 5px;
}
.center {
  align-items: center;
  align-content: center;
  justify-content: center;
}
.columns {
  flex-direction: column;
}
.rows {
  flex-direction: row;
}
.item {
  flex: 1;
}
.photo > img {
  height: 700px;
}
.delete-btn {
  width: 10px;
  padding: 20px;
  position: absolute;
  z-index: 999;
  right: 20px;
}
.btn {
  padding-top: 15px;
  padding-bottom: 15px;
  border-radius: 5px;
  background-color: #e6e5e5;
  border-bottom: 3px solid rgb(0, 0, 0);
  font-weight: 700;
  cursor: pointer;
}

.w-color {
  padding: 25px;
  border-radius: 5px;
  background-color: #c2c2c2;
  margin-left: 10px;
  border-bottom: 3px solid rgb(0, 0, 0);
  border-left: 1px solid rgb(0, 0, 0);
  font-weight: 700;
  cursor: pointer;
  &.active {
    border-bottom: 0px solid #333;
    border-left: 0px solid #333;
    filter: grayscale(30%);
  }
}
.secondary {
  margin-top: 15px;
  padding-top: 25px;
  padding-bottom: 25px;
  color: #0ab26e;
  background: #fff;
  border: 3px solid #0ab26e;
  text-align: center;
  box-shadow: 2px 3px 2px #8a8a8a;
  &:hover {
    background: #0ab26e;
    color: #fff;
  }
}

.w-size {
  padding: 15px;
  border-radius: 5px;
  background-color: #c2c2c2;
  margin-left: 10px;
  border-bottom: 3px solid rgb(0, 0, 0);
  border-left: 1px solid rgb(0, 0, 0);
  font-weight: 700;
  cursor: pointer;

  &.active {
    /* border: 1px solid #333; */
    border-bottom: 0px solid #333;
    border-left: 0px solid #333;
    background-color: #0ab26e;
  }
}

.buy {
  margin-top: 15px;
  margin-left: 0px;
  background-color: #c3c3c3;
  color: #fff;
  background-color: #0ab26e;
  text-align: center;
  font-size: 18px;
  font-weight: 800;
  padding-top: 25px;
  padding-bottom: 25px;
  border-radius: 5px;
  width: 100%;
}

hr {
  height: 0px;
  width: 100%;
  border-bottom: 1px solid rgba(51, 51, 51, 0.996);
}

.item input {
  width: 97%;
  height: 40px;
  font-size: 21px;
  padding-left: 10px;
  border-radius: 5px;
}
.simulator {
  position: relative;
  max-width: 700px;
}

.name-simulator {
  color: #fff;
  font-size: 32px;
  font-weight: 700;
  min-height: 55px;
  font-family: Muli, sans-serif;
  font-style: normal;
}
.phone-simulator {
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  font-family: Muli, sans-serif;
  font-style: normal;
}
.simulator-position {
  position: absolute;
  text-align: center;
  z-index: 10;
  top: -9%;
  left: -25%;
  width: 100%;
  height: 100%;
  padding-top: 50%;
  transform: rotate(19deg);
  &.onlyName {
    top: -8%;
    left: -25%;
    .name-simulator {
      font-size: 36px !important;
    }
  }
}
.top-widget {
  max-width: 1366px;
  margin: 0 auto;
  margin-bottom: 35px;
}

.color-3514724_1 {
  background: #a3cb61;
}

.color-3514724_2 {
  background: #f67ac7;
}

.color-3514724_3 {
  background: #9e64d0;
}

.color-3514724_4 {
  background: #d4334e;
}

.color-3514724_5 {
  background: #1a64e5;
}

.color-3514724_6 {
  background: #c35c8d;
}

.color-3514724_7 {
  background: url("../../assets/imgs/color/3514724_7.jpg");
}

.color-3514724_8 {
  background: #111111;
}

.color-3514724_9 {
  background: url("../../assets/imgs/color/3514724_9.jpg");
}

@keyframes zoominoutsinglefeatured {
  0% {
    transform: scale(1, 1);
  }
  50% {
    transform: scale(1.1, 1.1);
  }
  100% {
    transform: scale(1, 1);
  }
}
.button-animate {
  animation: zoominoutsinglefeatured 1s infinite;
}

.loader {
  border: 16px solid #f3f3f3; /* Light grey */
  border-top: 16px solid #3498db; /* Blue */
  border-radius: 50%;
  width: 120px;
  height: 120px;
  animation: spin 2s linear infinite;
}

.current-price {
  color: #0ab26e;
  font-size: 36px;
}

#background-loader {
  position: fixed;
  display: flex !important;
  flex-direction: column;
  color: #fff;
  font-weight: 700;
  align-content: center;
  align-items: center;
  align-self: center;
  justify-content: center;
  z-index: 1000;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.hide-loader {
  display: none;
}

.group-input {
  &.errors input {
    border: 1px solid red;
    border-radius: 4px;
  }
  .erros-alert {
    display: inline-block;
    color: red;
    font-size: 11px;
  }
}

.nojuros {
  font-weight: 700;
  color: #0ab26e;
}

@media screen and (max-width: 1280px) {
  h2 {
    font-size: 18px;
  }
  .rows {
    flex-direction: column;
  }
  .photo > img {
    width: 100%;
    height: auto;
  }
  .item input {
    width: 95%;
  }
  .w-color {
    margin-left: 5px;
  }
  .w-size {
    margin-left: 5px;
  }
  .name-simulator {
    color: #fff;
    font-size: 18px;
    font-weight: 700;
    min-height: 22px;
    font-family: Muli, sans-serif;
    font-style: normal;
  }
  .phone-simulator {
    color: #fff;
    font-size: 10px;
    font-family: Muli, sans-serif;
    font-style: normal;
  }
  .add {
    margin-top: 15px;
    padding-top: 25px;
    padding-bottom: 25px;
  }
  .btn {
    padding: 35px;
    margin-top: 5px;
    text-align: center;
  }
  .delete-btn {
    position: absolute;
    z-index: 999;
    width: auto;
    font-size: 20px;
    padding: 20px;
    position: absolute;
    right: 10px !important;
  }

  .secondary {
    margin-top: 15px;
  }
  .buy {
    width: 100%;
    padding-left: 0px;
    padding-right: 0px;
    padding-top: 35px;
    padding-bottom: 35px;
    margin-left: 0px;
    margin-top: 30px;
    text-align: center;
  }

  .simulator-position {
    height: 25%;
    top: -20px;
    left: -50px;

    &.onlyName {
      top: -16px;
      left: -46px;
      .name-simulator {
        font-size: 19px !important;
      }
    }
  }
}
.primary {
  margin-top: 15px;
  padding-top: 25px;
  padding-bottom: 25px;
  color: #fff;
  background: #0ab26e;
  border: 3px solid #0ab26e;
  text-align: center;
  box-shadow: 2px 3px 2px #8a8a8a;
  &:hover {
    background: #0ab26e;
    color: #fff;
  }
}

.maxconfirmation{
  max-width: 200px;
}
</style>
